import React from "react";
import { Building, User } from "lucide-react";

import { CreditAccountProduct } from "../../../api/credit_accounts";
import { isBusinessProduct } from "../logic/slice";

export interface AccountHolderIconProps {
  product?: CreditAccountProduct;
}

const AccountHolderIcon: React.FC<AccountHolderIconProps> = ({ product }) => {
  if (!product) return null;

  if (isBusinessProduct(product)) {
    return <Building width="16" height="16" className="text-[#737373]" />;
  }

  return <User width="16" height="16" className="text-[#737373]" />;
};

export default AccountHolderIcon;
